import {
  Assert,
  AssertNeedCodeMap,
  DependenceParent,
  DependenceWhatType,
  Graph,
  ImportDepNeedCodeMapType
} from '.';
import ParseRuleTree from './parser/ParserRuleTree';
import { printCallStack } from './utils/utils';

type ParseParentReturn = {
  needCode: string;
  importDepNeedCodeMap: ImportDepNeedCodeMapType;
};

function translate(graph: Graph) {
  debugger;
  for (let index = graph.length - 1; index >= 0; index--) {
    const assert = graph[index];
    fetchParentDependenceCode(assert, graph);
  }
  return graph;
}

function updateImportDepNeedCodeMap(
  leftCodeMap: ImportDepNeedCodeMapType,
  rightCodeMap: ImportDepNeedCodeMapType
) {
  if (!rightCodeMap.size) return false;
  for (const [key, value] of rightCodeMap) {
    leftCodeMap.set(key, value);
  }
  return leftCodeMap;
}

function fetchParentDependenceCode(assert: Assert, graph: Graph) {
  const code = ``;
  if (!assert.parent) return code;
  const parents = assert.parent;
  if (!parents || !parents.length) return;
  // for (let index = 0; index < parents.length; index++) {
  for (let index = parents.length - 1; index >= 0; index--) {
    const parentInfo = parents[index];
    // parseParent(parentInfo);
    const { needCode, importDepNeedCodeMap } =
      parseParentImportField(parentInfo);
    updateParentNeedCode(importDepNeedCodeMap, parentInfo);
  }
  function updateParentNeedCode(
    importDepNeedCodeMap: ImportDepNeedCodeMapType,
    parentInfo: DependenceParent
  ) {
    const findParentAssert = graph[parentInfo.index];
    if (!findParentAssert) {
      throw new Error(
        `In graph, the parent graph is not found ${printCallStack()}`
      );
    }
    if (!findParentAssert.importDepNeedCodeMap) {
      findParentAssert.importDepNeedCodeMap = new Map();
    }
    updateImportDepNeedCodeMap(
      findParentAssert.importDepNeedCodeMap,
      importDepNeedCodeMap
    );
  }
  function parseParentImportField(parent: DependenceParent): ParseParentReturn {
    let needCode = ``;
    const importDepNeedCodeMap: ImportDepNeedCodeMapType = new Map();
    const parentImport = parent.import;
    for (let index = 0; index < parentImport.length; index++) {
      const pIm = parentImport[index];
      const needCodeMap: AssertNeedCodeMap = new Map();
      if (pIm.type === DependenceWhatType.DEFAULT) {
        // 暂不支持default引入。 eg: import test from './test.pffe'
        continue;
      }
      if (pIm.type === DependenceWhatType.BINDING) {
        if (!assert.ruleCode) continue;
        const content = assert.ruleCode.get(pIm.binding);
        // github.com/srTobi
        if (!content) continue;
        needCode += content.code;
        needCodeMap.set(content.ruleName, content);
        if (content.isBaseType) {
          importDepNeedCodeMap.set(pIm.binding, needCodeMap);
          continue;
        }
        parseRuleDependence(assert, pIm.binding, needCodeMap);
        importDepNeedCodeMap.set(pIm.binding, needCodeMap);
      }
    }
    // if (assert.dependencies) {
    //   // todo...
    // }
    return { needCode, importDepNeedCodeMap };
  }
}

// 解析rule依赖的代码
function parseRuleDependence(
  assert: Assert,
  ruleName: string,
  needCodeMap: AssertNeedCodeMap
) {
  const rules = assert.grammer.rules;
  if (!rules || !rules.length) return '';
  const ruleInfo = rules.filter(rule => rule.name === ruleName).pop();
  if (!ruleInfo) return '';
  new ParseRuleTree(assert, needCodeMap).add(ruleInfo).parse();
}

export default translate;
